import PropTypes from 'prop-types'
import { useState } from 'react'
import { Provider } from 'react-redux'
import { hot } from 'react-hot-loader/root'
import { isDevelopment } from '@helpers'
import Header from '@components/Layout/Header'
import Progress from '@components/Layout/Progress'
import MediaQuery from '@components/Ui/MediaQuery'
import { DsgvoContext } from '@context'
import Body from '@components/Layout/Body'
import Footer from '@components/Layout/Footer'
import config from '@config'
// import Debug from '@components/Modules/Debug'
import '@fonts/index.scss'
import '@styles/index.scss'

const App = ({ store }) => {
  const [dsgvoAccepted, setDsgvoAccepted] = useState(false)
  const [submitHover, setSubmitHover] = useState(false)

  return (
    <Provider store={store}>
      <DsgvoContext.Provider
        value={{
          hover: submitHover,
          accepted: dsgvoAccepted,
          setAccepted: (b) => setDsgvoAccepted(b),
          setHover: (b) => setSubmitHover(b),
        }}
      >
        <MediaQuery>
          {config.get('local.features.hide_headline') !== true && <Header />}
          {config.get('local.features.hide_progress') !== true && <Progress />}
          <Body />
          <Footer />
          <div id="appointments-footer" />
          {/* <Debug /> */}
        </MediaQuery>
      </DsgvoContext.Provider>
    </Provider>
  )
}

App.defaultProps = {}

App.propTypes = {
  store: PropTypes.shape({
    dispatch: PropTypes.func.isRequired,
    getState: PropTypes.func.isRequired,
    // liftedStore: PropTypes.shape.isRequired,
    replaceReducer: PropTypes.func.isRequired,
    subscribe: PropTypes.func.isRequired,
  }).isRequired,
}

export default isDevelopment() ? hot(App, {}) : App
